import { useEffect, useState } from "react";

/**
 * Counts down locally from the server's `seconds_left`, restarting whenever a
 * new snapshot brings a new value. The server decides when time is up (the
 * watcher releases the machine); this only keeps the number moving between
 * snapshots, so the customer's clock never decides anything.
 */
export function useCountdown(secondsLeft: number | null | undefined, snapshotKey: string): number | null {
  const [left, setLeft] = useState<number | null>(secondsLeft ?? null);

  useEffect(() => {
    if (secondsLeft === null || secondsLeft === undefined) {
      setLeft(null);
      return;
    }
    const started = Date.now();
    setLeft(secondsLeft);
    const id = window.setInterval(() => {
      const elapsed = Math.floor((Date.now() - started) / 1000);
      setLeft(Math.max(0, secondsLeft - elapsed));
    }, 250);
    return () => window.clearInterval(id);
  }, [secondsLeft, snapshotKey]);

  return left;
}
